import styled from 'styled-components'

import { useHapticFeedback } from '@blade/ui-kit'

import type { IconProps } from '@root/shared/ui-kit'

type ActionsListItemVariant = 'normal' | 'dark'
type ActionsListItemProps = {
  icon: React.FC<IconProps>
  color: string
  onClick: () => void
  label: string
  variant?: ActionsListItemVariant
}

export const ActionsListItem = (props: ActionsListItemProps) => {
  const haptics = useHapticFeedback()

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation()
    haptics.impactOccurred('light')
    props.onClick()
  }
  const IconEl = props.icon

  return (
    <Root
      $variant={props.variant ?? 'normal'}
      type="button"
      onClick={handleClick}
    >
      <Icon $color={props.color}>
        <IconEl size={16} />
      </Icon>
      <Label>{props.label}</Label>
    </Root>
  )
}

const VariantToBackground: Record<ActionsListItemVariant, string> = {
  dark: 'var(--appearance-1)',
  normal: 'var(--backgroundA-3)',
}
const Root = styled.button<{ $variant: ActionsListItemVariant }>`
  all: unset;
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  padding: 12px;
  align-items: center;
  gap: 11px;
  width: 100%;
  border-radius: 12px;
  background: ${(x) => VariantToBackground[x.$variant]};

  transition: background 0.2s ease-in-out;

  &:hover,
  &:focus {
    background: var(--backgroundA-5);
  }

  &:active {
    background: var(--backgroundA-6);
  }
`
const Icon = styled.div<{ $color: string }>`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  padding: 12px;
  background: ${(x) => x.$color};
`

const Label = styled.div`
  font-size: 14px;
  line-height: normal;
  font-weight: 600;
`
